import { G_BUTTON__fields_images_clear_content } from './_buttons/G_BUTTON__fields_images_clear_content';
import { G_BUTTON__fields_images_visibility_of__read_only } from './_buttons/G_BUTTON__fields_images_visibility_of__read_only';

export function G_BAR__images_fields_buttons() {
  return (
    <div className="flex-shrink-0 min-h-0 w-full h-6 overflow-auto flex flex-row items-center justify-between gap-2 px-2 bg-bar border-b border-component-border">
      <G_BUTTON__fields_images_clear_content />
      <G_BUTTON__fields_images_visibility_of__read_only />
    </div>
  );
}
